<!--单位授信数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                                :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                                       slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'crType'" v-model="sendDataInfo[formOneValue.entityField]" size="mini" @input="crTypeChange">
                                                        <el-radio-button v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key"
                                                                         :label="Number(matItem.key)">{{ String(Number(matItem.value)) == 'NaN' ? matItem.value : matItem.key }}</el-radio-button>
                                                    </el-radio-group>
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0" @visible-change="selectChange"
                                                               v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key"
                                                                   :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                                   :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                                    </el-select>

                                                    <el-date-picker v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                                    value-format="timestamp">
                                                    </el-date-picker>
                                                    <el-input class="form_codition" v-else type="text" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                              v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,formOneValue.fieldType, formOneValue.formatterContent) }}
                                                    </span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>

            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :parentSearchData="parentSearchData" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "unitCreditAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0 // 0新增，1修改
            },
            detaislDataInfo: {},
            selectedDataIndex: 0,
            sendDataInfo: {},
            showTabs: "",
            tabForm: [],
            footForm: [],
            DialogVisible: false, //检索
            parentSearchData: {},
            seId: "",
            seWidth: "",
            seTitle: "",
            seType: "",
            isLoaded: false,
            inputel: [],
            pickerOptions: {
                disabledDate(time) {
                    //选择今天以及今天之后的日期
                    // return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择
                    return time.getTime() < Date.now();
                    //选择今天以及今天之前的日期
                    // return time.getTime() > Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
                }
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
        getValue(val, type, fieldType, arr) {
            var str = "";
            if (type == "bgiType" || fieldType == "formatter") {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key;
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value;
                        }
                    });
                }
            } else {
                str = val || "";
            }
            return String(str);
        },
        selValidity(e) {
            let nowTime = new Date();
            let hour = nowTime.getHours();
            let minute = nowTime.getMinutes();
            let second = nowTime.getSeconds();
            let s = (hour * 3600 + minute * 60 + second) * 1000;
            if (e == 0) {
                this.sendDataInfo.validity = this.sendDataInfo.validity + s;
            } else if (e == 1) {
                this.sendDataInfo.paymentDate = this.sendDataInfo.paymentDate + s;
            }
        },
        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId);
            // this.$emit('toDetail',orderId)
        },
        //类型改变检索改变，输入框改变
        crTypeChange() {
            console.log(this.sendDataInfo.crType)
            if (this.sendDataInfo.crType == 1) {
                this.seId = "3391151360249856";
            } else {
                this.seId = "3386264207560704";
            }
            this.sendDataInfo.unitId = "";
            this.sendDataInfo.unitName = "";
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            if (!sId) {
                if (this.sendDataInfo.crType == 1) {
                    this.seId = "3391151360249856";
                    this.sField = sField;
                    this.fField = "";
                    this.parentSearchData.cmName = this.sendDataInfo[type]
                } else {
                    this.seId = "3386264207560704";
                    this.sField = sField;
                    this.fField = "";
                    this.parentSearchData.smName = this.sendDataInfo[type]
                }
            } else {
                this.seId = sId;
                this.sField = sField;
                this.fField = fField;
            }
            this.seIndex = index;
            this.seType = type;
            this.DialogVisible = true;
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        //提取返回
        changeInputModel(val) {
            this.DialogVisible = false;
            if (val && (val != "" || val != undefined)) {
                if (this.sendDataInfo.crType == 1) {
                    this.sendDataInfo.unitName = val.cmName
                    this.sendDataInfo.unitId = val.cmId
                } else {
                    this.sendDataInfo.unitName = val.smName
                    this.sendDataInfo.unitId = val.smId
                }
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val, flag) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (item!='unitName'&&item!='unitId') {
					this.$set(this.sendDataInfo, item, val[item])
				}
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },

        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate((valid, invalidFields) => {
                console.log("验证失败的字段：", invalidFields);
                if (valid) {
                    // console.log(this.sendDataInfo)
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error"
                    });
                    return false;
                }
            });
        },
        async sub() {
            var responseData;
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.unitCreditAddUnitCredit(
                    this.sendDataInfo
                );
            } else {
                responseData = await this.$http.unitCreditUpdateUnitCredit(
                    this.sendDataInfo
                );
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success"
                });
                this.$emit("drawerCancel");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error"
                });
            }
        },

        //取消
        initActionBox(sendDataInfo) {
            this.init();
            this.$emit("drawerCancel");
            this.$refs[sendDataInfo].resetFields();
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "crType") {
                    this.sendDataInfo[key] = 0;
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.sendDataInfo.rcnId = dataInfo.rcnId;
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach(item1 => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach(item2 => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0;
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1;
                        index1++;
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                if (key == 'crType') {
                    this.$set(this.sendDataInfo, "crType", 0)
                }else{
                    this.$set(this.sendDataInfo, key, obj[key]);
                }
            }
            this.$set(this.sendDataInfo, 'unitName', "");
            this.$set(this.sendDataInfo, 'unitId', "");
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        }
    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            var params = this.actionData;
            this.openBox();
            //   this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>
